import styled from 'styled-components';

export const TimelineCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.875rem;
	font-family: inherit;
	width: 100%;
	height: auto;
`;

export const TimelineWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
`;
